import PropTypes from 'prop-types'

import styles from './StepHeader.module.css'

// Spec §5.11 — screen title + "Step n/2" indicator + a one-line description.
const StepHeader = ({ title, step, totalSteps, description }) => (
  <div className={styles.wrapper}>
    <div className={styles.titleRow}>
      <span className={styles.title}>{title}</span>
      {step && (
        <span className={styles.step}>
          Step {step}/{totalSteps}
        </span>
      )}
    </div>
    {description && <p className={styles.description}>{description}</p>}
  </div>
)

StepHeader.propTypes = {
  title: PropTypes.string.isRequired,
  step: PropTypes.number,
  totalSteps: PropTypes.number,
  description: PropTypes.node,
}

StepHeader.defaultProps = {
  totalSteps: 2,
}

export default StepHeader
